<template>
  <div class="print-card" :data-testid="testId">
    <h2 class="print-card__title">{{ title }}</h2>
    <div
      class="print-card__content"
      data-private
      :class="{ 'card-padding': hasPadding }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',

  props: {
    title: {
      type: String,
      required: true,
    },
    testId: {
      type: String,
      required: false,
      default: 'print-card',
    },
    hasPadding: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen, print {
  .print-card {
    margin-bottom: 8px;

    &__title {
      padding: 4px 10px;
      background-color: $color-blue-grey-darken1 !important;
      font-size: 14px;
      color: $color-white !important;
      margin: 0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;

      &::first-letter {
        text-transform: capitalize;
      }
    }

    &__content {
      height: 100%;
      box-sizing: border-box;
      border: 1px solid $color-blue-grey-darken1;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  .card-padding {
    padding: 8px;
  }
}
</style>
